// extracted by mini-css-extract-plugin
export var standaloneTable = "_jn-0";
export var standaloneTableWithBodyFill = "_jn-1";
export var withExtraHeader = "_jn-2";